import React, { Component } from 'react';
import { Button, Card, CardActions, CardHeader, Icon, IconButton } from '@material-ui/core';
import { withRouter } from 'react-router-dom';

class ContactUs extends Component {

    goToContactUs(e) {
        this.props.history.push("/contactUs");
        e.stopPropagation();
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={this.props.className}>
                <Card className="card without-padding full-height" onClick={this.goToContactUs.bind(this)}>
                    <CardHeader title={"Nous contacter"} titleTypographyProps={{ variant: "h6", color: 'primary' }}
                        avatar={
                            <Icon className={classes.iconStyle}>contact_support</Icon>
                        }
                        action={
                            <IconButton color="inherit" onClick={this.props.close} aria-label="Close">
                                <Icon>close</Icon>
                            </IconButton>
                        }
                    />
                    <CardActions className={classes.cardActions} disableSpacing>
                        <Button variant="contained" size="small" color="secondary" onClick={this.goToContactUs.bind(this)}
                            startIcon={<Icon>arrow_forward</Icon>} className={classes.smallButton}>
                            Voir
                    </Button>
                    </CardActions>
                </Card>
            </div >
        );
    }
}

export default withRouter(ContactUs);
